import { FormikTouched, FormikErrors } from 'formik';
import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import { IProperties } from '../../../builder/types';
import { Input } from '../../../../../components/TextInput';

interface IFillingCheckBoxesProps {
  properties: IProperties,
  touched: FormikTouched<any>,
  errors: FormikErrors<any>,
  values: any,
  disabled?:boolean,
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
}

export const FillingCheckBoxes: React.FC<IFillingCheckBoxesProps> = ({ properties, touched, errors, values, setFieldValue, disabled }) => {
  console.log({
    properties,
    values
  })
  return (
    <Flex flex={1}>
      <Flex flexDirection={'column'} flex={1 / 4}>
        <Text onClick={() => { }} fontWeight={500}>
          {`${((properties || {}).params || {}).question || 'Question'}${(((properties || {}).params || {}).ctrlProps || {}).required ? '*' : ''}`}
        </Text>
        <Text fontSize={'12px'} fontWeight={300}>
          {((properties || {}).params || {}).description || ''}
        </Text>
      </Flex>
      <Flex ml={3} flex={1} justifyContent={'flex-start'} flexDirection={'column'}>
        {((((properties || {}).params || {}).ctrlProps || {}).options || []).map((x) => {
          return (
            <Flex mb={2}>
              <Input
              disabled={disabled}
                type="checkbox"
                checked={values[`${properties.id}__${x.value}`]}
                onClick={(e: any) => setFieldValue(`${properties.id}__${x.value}`, e.target.checked)}
                id={`${properties.id}_${x.value}`}
                name={`${properties.id}_${x.value}`}
              />
              <label htmlFor={`${properties.id}__${x.value}`} style={{ marginLeft: '16px' }}>
                {x.label}
              </label>
            </Flex>
          );
        })}
      </Flex>
    </Flex>);
}